/* ============================================================
   FOCUS SKINCARE — custom-marquee.js
   Script de la section « Ils parlent de nous » (logo-marquee).
   Fichier autonome : chargé par sections/logo-marquee.liquid.
   Aucun fichier de base n'est modifié.
   ------------------------------------------------------------
   #FS-LOGO-MARQUEE
   Rend le marquee de logos réellement infini quel que soit
   l'écran, et convertit la « vitesse » (px/seconde) en durée
   d'animation exacte.
   ============================================================ */

(function () {
  'use strict';

  if (window.__fsMarqueeJsLoaded) return;
  window.__fsMarqueeJsLoaded = true;

  /* ---------- #FS-LOGO-MARQUEE ---------- */

  var MIN_GROUPS = 2;
  var MAX_GROUPS = 24;

  /**
   * Un SVG collé sans attribut viewBox ne se redimensionne pas : lui donner
   * une hauteur en CSS ne fait que rétrécir sa fenêtre → le logo est rogné.
   * On reconstruit donc un viewBox à partir de ses dimensions d'origine
   * (ou de sa boîte englobante réelle), puis on retire width/height.
   */
  function normalizeSvgs(scope) {
    var svgs = scope.querySelectorAll('.fs-mq__logo--inline svg');

    for (var i = 0; i < svgs.length; i++) {
      var svg = svgs[i];
      if (svg.__fsNormalized) continue;
      svg.__fsNormalized = true;

      if (!svg.getAttribute('viewBox')) {
        var wAttr = svg.getAttribute('width') || '';
        var hAttr = svg.getAttribute('height') || '';
        var w = wAttr.indexOf('%') === -1 ? parseFloat(wAttr) : NaN;
        var h = hAttr.indexOf('%') === -1 ? parseFloat(hAttr) : NaN;

        if (w > 0 && h > 0) {
          svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
        } else {
          try {
            var bb = svg.getBBox();
            if (bb.width > 0 && bb.height > 0) {
              svg.setAttribute('viewBox', bb.x + ' ' + bb.y + ' ' + bb.width + ' ' + bb.height);
            }
          } catch (e) {
            /* SVG non rendu : on laisse tel quel */
          }
        }
      }

      // La hauteur vient du CSS ; la largeur suit le ratio du viewBox.
      svg.removeAttribute('width');
      svg.removeAttribute('height');
      // Un style="width:…;height:…" en ligne écraserait la feuille de styles
      svg.style.removeProperty('width');
      svg.style.removeProperty('height');
      svg.style.removeProperty('max-width');
      svg.style.removeProperty('max-height');
      if (!svg.getAttribute('preserveAspectRatio')) {
        svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      }
    }
  }

  function groupWidth(group) {
    // getBoundingClientRect inclut le padding-right (= l'espacement entre logos)
    return group.getBoundingClientRect().width;
  }

  function buildMarquee(root) {
    var track = root.querySelector('[data-fs-marquee-track]');
    var viewport = root.querySelector('.fs-mq__viewport');
    if (!track || !viewport) return;

    var base = track.querySelector('[data-fs-marquee-group]');
    if (!base) return;

    // Corriger les SVG avant toute mesure de largeur
    normalizeSvgs(base);

    // On repart toujours d'un seul groupe de référence
    var extras = track.querySelectorAll('.fs-mq__group:not([data-fs-marquee-group])');
    for (var i = 0; i < extras.length; i++) extras[i].remove();

    var width = groupWidth(base);
    if (!width) return; // section masquée / pas encore mesurable

    var needed = Math.ceil((viewport.getBoundingClientRect().width * 2) / width);
    var count = Math.min(Math.max(needed, MIN_GROUPS), MAX_GROUPS);

    var frag = document.createDocumentFragment();
    for (var c = 1; c < count; c++) {
      var clone = base.cloneNode(true);
      clone.removeAttribute('data-fs-marquee-group');
      clone.setAttribute('data-fs-marquee-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      // Neutralise les attributs de l'éditeur de thème sur les copies
      var edited = clone.querySelectorAll('[data-shopify-editor-block]');
      for (var e = 0; e < edited.length; e++) {
        edited[e].removeAttribute('data-shopify-editor-block');
      }
      // Évite les doublons de liens pour les lecteurs d'écran / la tabulation
      var links = clone.querySelectorAll('a');
      for (var l = 0; l < links.length; l++) links[l].setAttribute('tabindex', '-1');
      frag.appendChild(clone);
    }
    track.appendChild(frag);

    var speed = parseFloat(root.getAttribute('data-speed')) || 60; // px / seconde
    var duration = width / speed;
    if (duration < 1) duration = 1;

    root.style.setProperty('--fs-mq-groups', count);
    root.style.setProperty('--fs-mq-duration', duration.toFixed(3) + 's');

    // Redémarrage propre de l'animation après recalcul
    track.style.animation = 'none';
    void track.offsetWidth;
    track.style.animation = '';
  }

  function initMarquee(root) {
    buildMarquee(root);

    // Les images (logos) peuvent arriver après le premier calcul
    var imgs = root.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].complete) {
        imgs[i].addEventListener('load', function () { buildMarquee(root); }, { once: true });
      }
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { buildMarquee(root); });
    }

    if (typeof ResizeObserver === 'function') {
      var last = 0;
      var ro = new ResizeObserver(function (entries) {
        var w = Math.round(entries[0].contentRect.width);
        if (Math.abs(w - last) < 2) return;
        last = w;
        buildMarquee(root);
      });
      ro.observe(root.querySelector('.fs-mq__viewport'));
    }
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-fs-marquee]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].__fsMarqueeReady) continue;
      nodes[i].__fsMarqueeReady = true;
      initMarquee(nodes[i]);
    }
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  ready(function () { initAll(document); });
  window.addEventListener('load', function () { initAll(document); });

  /* ---------- Éditeur de thème Shopify ---------- */

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest('[data-fs-marquee]');
    if (!root) return;
    var track = root.querySelector('[data-fs-marquee-track]');
    if (track) track.style.animationPlayState = 'paused';
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var root = event.target.closest('[data-fs-marquee]');
    if (!root) return;
    var track = root.querySelector('[data-fs-marquee-track]');
    if (track) track.style.animationPlayState = '';
  });
})();